import * as React from 'react'
import { KeravaRadarButton } from '../elements/button'
import { IViewChange } from '../types/index'
import styled from '../theme/styled'

const Wrapper = styled.div`
  width: 100px;
  }
`

class ViewSwitchButton extends React.PureComponent<IViewChange, {}> {

  public switchView = () => {
    this.props.stopTimer()
    this.props.resetId()
    this.props.changeView()
  }

  render() {
    return (
      <Wrapper>
        <KeravaRadarButton width="100%" onClick={this.switchView}>
          switch
        </KeravaRadarButton>
      </Wrapper>
    )
  }
}

export default ViewSwitchButton



// WEBPACK FOOTER //
// ./src/components/ViewSwitchButton.tsx